import React, { useEffect } from 'react';
import { View, type ViewProps } from 'react-native';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
  withDelay,
  withSpring,
  Easing,
} from 'react-native-reanimated';
import { AnimatedView } from './animated';


export interface ScaleInViewProps extends ViewProps {
  delay?: number;
  duration?: number;
  useSpring?: boolean;
  initialScale?: number;
  className?: string;
  children: React.ReactNode;
}

export function ScaleInView({
  delay = 0,
  duration = 300,
  useSpring = false,
  initialScale = 0.8,
  className,
  children,
  style,
  ...props
}: ScaleInViewProps) {
  const scale = useSharedValue(initialScale);
  const opacity = useSharedValue(0);

  useEffect(() => {
    scale.value = initialScale;
    opacity.value = 0;

    if (useSpring) {
      scale.value = withDelay(
        delay,
        withSpring(1, {
          damping: 15,
          stiffness: 150,
        }),
      );
      opacity.value = withDelay(
        delay,
        withSpring(1, {
          damping: 15,
          stiffness: 150,
        }),
      );
    } else {
      scale.value = withDelay(
        delay,
        withTiming(1, {
          duration,
          easing: Easing.out(Easing.cubic),
        }),
      );
      opacity.value = withDelay(
        delay,
        withTiming(1, {
          duration,
          easing: Easing.out(Easing.cubic),
        }),
      );
    }
  }, [delay, duration, useSpring, initialScale, scale, opacity]);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
    transform: [{ scale: scale.value }],
  }));

  // Classes de layout ficam num View puro: className em animated components é
  // ignorado/clobberado no nativo, o que colapsa flex-1/min-h dos filhos.
  return (
    <View className={className} style={style} {...props}>
      <AnimatedView style={[{ flexGrow: 1, flexShrink: 1 }, animatedStyle]}>
        {children}
      </AnimatedView>
    </View>
  );
}
